import React from 'react';

const HeroHeading = () => {
    return (
        <div className="text-center">
            <h2 className="my-16 text-3xl font-bold text-[#001C3D] leading-tight">
                The #1 app for finding gluten-free safe places
            </h2>
        </div>
    );
};

export default HeroHeading; 